import {configureStore} from "@reduxjs/toolkit";
import reducer from "./reducer";

const fn = () => {
  return configureStore({
    reducer: reducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });
};
export default fn;
